import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';

export default class AnalizaVanzarilorCrossSell extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

            bilantData:[],
            mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
            { id: 'avc', label: 'Analiza de vanzari si client (AVC)', color: '#900DCB' },

            ],
            listSold: { Clienti: {}, Furnizori: {} }
        }
    }

    componentDidMount() {
        this.getCrossSellData()
    }

    getCrossSellData = async () => {
        let fs = new FromServer();

        let getData = await fs.getEvaluare()

        // console.log('chartData2 :', chartData2);

        // console.log('chartData2 :', chartData2);


        // console.warn('listCapitole :', getData);

        if (getData.r) {

            let profitulNet = getData.c.listCapitole.filter(c => c.capitol === 'Analiza cash flow')[0].categorii

            let rataProfitului = getData.c.listCapitole.filter(c => c.capitol === 'Analiza de vanzari si clienti')[0].categorii


            // console.log('bilant :', profitulNet);



            let myData = []


           

            for (let i = 0, n = profitulNet.length; i < n; i++) {

                if (profitulNet[i].categorie === 'Analize profit si pierdere') {

                    myData.push(profitulNet[i].chartData[profitulNet[i].chartData.length - 1])
                }

            }

            for (let i = 0, n = rataProfitului.length; i < n; i++) {

                if (rataProfitului[i].categorie === 'Analiza vanzarilor aditionale (Cross-Sell) si a profitabilitatii') {

                    myData.push(rataProfitului[i].chartData[rataProfitului[i].chartData.length - 1])
                }

            }

            // console.log('myData :', myData);
            // console.log('profitulNet :', profitulNet);


            this.setState({
                bilantData: myData,
            })
        }
    }



    goTo = (id) => {
        this.props.history.push(`/${id}`)
    }
    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />

                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

                <div style={{ textAlign: 'left' }}>

                    {this.state.mapButtons.map((b, idx) => {
                        return (
                            <SiteMap
                                key={idx}
                                b={b}
                                buttonSelected={this.goTo} />

                        )
                    })}
                </div>
                <h1 className='pm-title'>Analiza vanzarilor aditionale (cross-sell) si a profitabilitatii</h1>

                {this.state.bilantData.map((b, idx) => {

                    if (b.chartData[0] === 0 && b.chartData[1] === 0) {
                        return (
                            <div key={idx} style={{ width: '45%', display: 'inline-block' }}>
                                <h2 className='pm-title'>{b.titlu}</h2>
                                <h4 style={{
                                    color: 'red',
                                    letterSpacing: 1,
                                    fontWeight: 600
                                }}>Informatiile necesare acestui grafic nu au fost gasite </h4>

                            </div>
                        )
                    }
                    return (
                        

                        <BilantChartData
                            ch={b}
                            key={idx}
                        />

                    )
                })}

            </div>
        );
    }
}